import React, { useState } from "react";
import { ArrowRight, Mail } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import Reveal from "./Reveal";
import { contact as C } from "../mock";

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: "Please fill in your name and email" });
      return;
    }
    toast({ title: "Message sent!", description: "Thanks — we'll be in touch shortly." });
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="contact" className="relative bg-[#0b0b0b] text-white py-24 md:py-32 px-5 overflow-hidden">
      <div className="max-w-[900px] mx-auto text-center relative z-10">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-4">{C.title}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl leading-tight">{C.headline}</h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-[#9a9a9a] mt-4 mb-12">{C.sub}</p>
        </Reveal>

        <Reveal delay={0.2}>
          <form onSubmit={submit} className="max-w-[560px] mx-auto text-left space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <input
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder={C.fields.name}
                className="bg-white/5 border border-white/10 rounded-xl px-5 py-4 outline-none focus:border-[#ff4d17] transition-colors placeholder:text-[#6f6f6f]"
              />
              <input
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder={C.fields.email}
                className="bg-white/5 border border-white/10 rounded-xl px-5 py-4 outline-none focus:border-[#ff4d17] transition-colors placeholder:text-[#6f6f6f]"
              />
            </div>
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder={C.fields.message}
              rows={4}
              className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 outline-none focus:border-[#ff4d17] transition-colors placeholder:text-[#6f6f6f] resize-none"
            />
            <button
              type="submit"
              className="group w-full bg-[#ff4d17] text-white py-4 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-[#e03e0d] transition-colors"
            >
              {C.fields.submit}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>
        </Reveal>

        <Reveal delay={0.25}>
          <a
            href={`mailto:${C.email}`}
            className="inline-flex items-center gap-2 mt-10 text-[#9a9a9a] hover:text-[#ff4d17] transition-colors"
          >
            <Mail size={16} />
            {C.email}
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
